import React from "react";
import CustomBanner from "components/General/Form/CustomBanner";
import AxiosConfig from "axiosConfig";
import TextTheme from "../../../components/General/Text/TextTheme";

class ActivateUser extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			status: "Verifying Activation Link...",
		};
	}

	componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let username = params.get('username');
        let activation = params.get('activation');
        let email = params.get('email');

        AxiosConfig.get('account/activate/', {params: {username: username, activation: activation, email: email}})
		.then(res => {
			if (res.data.status==='Invalid Activation Link') {
				this.setState({ status: "Invalid Activation Link" });
			}
			else {
				if(res.data.status==="SUCCESS")
				{
					this.setState({ status: "Success. Redirecting to login page..." });
				}
				else {
					this.setState({ status: res.data.status + ". Redirecting to login page..." });
				}

				setTimeout(() => {this.props.history.push('/log-in')}, 3000);
			}
		}).catch()
    }

    render() {
		return (
			<div>
				<CustomBanner message="Verify activation link." />
				<div style={{ textAlign: "-webkit-center" }}>
					<form className="form_register">
						<TextTheme
						message={this.state.status}
                        className="text_xm text_red"
                    	/>
						{this.state.status==='Invalid Activation Link'?(<div>
						<a className="subtext" href="/resend-activation">Resend activation link</a>
					</div>):null}
					</form>
				</div>

			</div>
		);
	}
}

export default ActivateUser;